const VERSION: string = '0.1.7-prod.9'
export default VERSION;
